module.exports = __webpack_public_path__ + "static/img/bride_wechat_qrcode.2d152ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bride_wechat_qrcode.jpg
// module id = 514
// module chunks = 1